<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

            <!-- Indicators -->
            <ul class="carousel-indicators">
                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                <li data-target="#assetSlide" data-slide-to="1"></li>
                <li data-target="#assetSlide" data-slide-to="2"></li>
            </ul>

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Appointment Slots</strong>   <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  translate type="text" placeholder="Search" 
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
                       
                        <th class=" p-2" translate>Full Name</th>
                        <th class="text-center p-2" translate>Request Type</th>
                        <th class="text-center p-2" translate>Sales Rep</th>
                        <th class="text-center p-2" translate>Phone</th>
                        <th class="text-center p-2" translate>Time In</th>
                        <th class="text-center p-2" translate>Time Out</th>
                        <th class="text-center p-2" translate>Date Submitted</th>
                        <th class="text-center p-2" translate>Status</th>
                        <th class="text-center p-2" translate>Action</th>
                       
                       
                      <!--  <tr  *ngFor='let list of alltodaysappointment | filter:searchText'>
                            <td class="p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                            <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                            <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                           <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                           <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center p-2" (click)=openAppointment(list) style="cursor: pointer;" >{{list.dateSubmitted  | date:'yyyy-M-d h:mm a'}}</td>
                          
                          
                          
                           <td  *ngIf="list.status==''" class="text-warning text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-2"><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-2"><strong>{{list.status}}</strong></td>

                            <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                <i class="fa fa-trash p-2" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                <i class="fa fa-edit text-info p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                <i class="fa fa-check-square text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i></td>
                           
                           
                       
                    
                          

                       
                        </tr>-->
                    </table>
               </div>
                    </div>
                </div>


            
            </div>


        </div>
      
</div>


       
        </div>

        </div>

